import { render, staticRenderFns } from "./KarteImageList.vue?vue&type=template&id=2241828d&scoped=true&"
import script from "./KarteImageList.vue?vue&type=script&lang=js&"
export * from "./KarteImageList.vue?vue&type=script&lang=js&"
import style0 from "./KarteImageList.vue?vue&type=style&index=0&id=2241828d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2241828d",
  null
  
)

export default component.exports